import React from "react";
import { Link } from "react-router-dom";
import { Heart, Mail, MapPin, Phone, Instagram, Facebook, Linkedin, Youtube } from "lucide-react";
import logo from "../../images/Headerlogo.png";

const socialLinks = [
  { href: "https://www.instagram.com/kindnessunlimited/", icon: Instagram, label: "Instagram" },
  { href: "https://www.facebook.com/KindnessUnlimited.in/", icon: Facebook, label: "Facebook" },
  { href: "https://www.linkedin.com/company/kindness-unlimited/", icon: Linkedin, label: "LinkedIn" },
  { href: "https://www.youtube.com/user/KindnessUnlimited", icon: Youtube, label: "YouTube" },
];

const contactDetails = [
  { icon: MapPin, text: "A-102, Ajanta Sant Muktabai Road, Vile Parle(E), Mumbai-400057" },
  { icon: Phone, text: "+91 9820710081" },
  { icon: Mail, text: "contactus@kindnessunlimited.in" },
];

const bankDetails = [
  { label: "SB A/c", value: "3736000107003253" },
  { label: "IFSC Code", value: "PUNB0373600" },
  { label: "Bank", value: "Punjab National Bank, Mumbai - 57" },
];

const Footer = () => {
  return (
    <footer className="bg-ku-purple-deep text-white">
      {/* Main Footer */}
      <div className="ku-container py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-12">

          {/* Brand Column */}
          <div>
            <Link to="/" className="inline-block mb-5">
              <img src={logo} alt="Kindness Unlimited" className="h-14 w-auto" />
            </Link>
            <p className="font-body text-white/70 text-sm leading-relaxed mb-5">
              Connecting India through the web of kindness a youth-centric, volunteer-led movement since 2005.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              {socialLinks.map(({ href, icon: Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center text-white/70 hover:bg-ku-gold hover:text-ku-purple-deep transition-all duration-200"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="font-display text-base font-bold mb-5 text-ku-gold tracking-wide">Get in Touch</h3>
            <div className="space-y-4 text-sm text-white/70 font-body">
              {contactDetails.map(({ icon: Icon, text }, index) => (
                <div key={index} className="flex gap-3">
                  <Icon className="w-4 h-4 text-ku-gold flex-shrink-0 mt-0.5" />
                  <p>{text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Contributions / Account Details */}
          <div>
            <h3 className="font-display text-base font-bold mb-5 text-ku-gold tracking-wide">Contributions</h3>
            <p className="font-body text-white/70 text-sm mb-4">
              Contributions can be made to the following account details:
            </p>
            <div className="space-y-3 text-sm text-white/70 font-body">
              {bankDetails.map(({ label, value }, index) => (
                <div key={index} className="flex gap-2">
                  <span className="font-semibold text-white/90">{label}:</span>
                  <span>{value}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* Trust Details + Copyright */}
      <div className="border-t border-white/10">
        <div className="ku-container py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/45 font-body">
          <div className="flex flex-wrap gap-x-6 gap-y-1 justify-center md:justify-start">
            <span>Trust Reg. E22702 (Jul 01, 2005)</span>
            <span>12-A Reg. TR/39936 (Apr 18, 2006)</span>
            <span>80-G Tax Exemption</span>
          </div>
          <div className="text-center md:text-right space-y-1">
            <p className="text-white/60">
              Made with <Heart className="w-3 h-3 inline text-ku-gold" fill="currentColor" /> by Kindness Unlimited
            </p>
            <p>
              Copyright &copy; {new Date().getFullYear()} Kindness Unlimited. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;